import { CheckboxChangeEvent } from 'antd/es/checkbox';
import { useState } from 'react';

import useTermsAndConditionStore from 'global/Securities/stores/useTermsAndConditionStore';
import { TnCFeatureIDEnum } from 'global/Securities/types/termsAndCondition';
import { PaymentMethod } from 'global/Securities/types/transaction';

import useUIConfigStore from 'stores/useUIConfigStore';
import Checkbox from '../../Checkbox';
import BaseSecuritiesModal, {
  BaseSecuritiesModalProps,
} from '../BaseSecuritiesModal';
import {
  AgreementWrapper,
  ContentContainer,
  TnCFrame,
  TnCFrameWrapper,
} from './styled';

interface TradingLimitModal extends BaseSecuritiesModalProps {
  checkboxText?: string;
}

const TradingLimitTncModal = ({
  title = 'Syarat & Ketentuan',
  checkboxText = 'Saya menyetujui Syarat & Ketentuan Penggunaan Trading Limit di atas.',
  onSubmit = () => {},
  ...props
}: TradingLimitModal) => {
  const FEATURE_ID = TnCFeatureIDEnum.FEATURE_TRADING_LIMIT;
  const [tncAgreed, setTncAgreed] = useState(false);

  const setUIValue = useUIConfigStore((s) => s.setUIValue);

  const isSubmitting = useTermsAndConditionStore((s) => s.isSubmitting);
  const contents = useTermsAndConditionStore((s) => s.contents);
  const postAcceptance = useTermsAndConditionStore((s) => s.postAcceptance);

  const handleCheckboxChange = (event: CheckboxChangeEvent) => {
    setTncAgreed(event.target.checked);
  };

  const handleTncSubmit = async () => {
    if (!tncAgreed) {
      return;
    }

    const tradingLimitContents = contents[FEATURE_ID];
    const [content] = tradingLimitContents.acceptanceLetters;

    await postAcceptance(FEATURE_ID, content.version);

    setUIValue('tradingLimitTnc', true);
    setUIValue('transactionPaymentMethod', PaymentMethod.TradingLimit);

    onSubmit();
  };

  let iframeSrc = '';

  if (contents && contents[FEATURE_ID]) {
    const tradingLimitContents = contents[FEATURE_ID];
    const [content] = tradingLimitContents.acceptanceLetters;
    iframeSrc = `${content.url}`;
  }

  return (
    <BaseSecuritiesModal
      title={title}
      submitText="Lanjut"
      submitProps={{ disabled: !tncAgreed, loading: isSubmitting }}
      onSubmit={handleTncSubmit}
      {...props}
    >
      <ContentContainer>
        <TnCFrameWrapper>
          <TnCFrame title="trading-limit-tnc" src={iframeSrc} />
        </TnCFrameWrapper>

        <AgreementWrapper>
          <Checkbox onChange={handleCheckboxChange}>{checkboxText}</Checkbox>
        </AgreementWrapper>
      </ContentContainer>
    </BaseSecuritiesModal>
  );
};

export default TradingLimitTncModal;
